import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { EXECUTION_SERVICE } from '@eggplant/api-hosts'
import { useGetParamsWithSpaceId } from '../useGetParamsWithSpaceId'
import type {
  PostExecutionsBody,
  PostExecutionsResponse
} from '@eggplant/types'
import type { ReactNode } from 'react'

interface Props {
  children?: (value: PostExecutionsResponse) => ReactNode
  onSuccess: (value: PostExecutionsResponse) => void
  params: PostExecutionsBody
}

const CreateExecutionServiceRequest = ({
  children,
  onSuccess,
  params
}: Props) => {
  const url = `${EXECUTION_SERVICE}/executions`
  const { requestParams } = useGetParamsWithSpaceId<PostExecutionsBody>(params)

  return (
    <AuthenticatedDataRequest
      method='post'
      onSuccess={onSuccess}
      params={requestParams}
      url={url}
    >
      {children}
    </AuthenticatedDataRequest>
  )
}

export default CreateExecutionServiceRequest
